import { useEffect, useState } from "react";

const query = (q) => typeof window !== "undefined" && window.matchMedia && window.matchMedia(q).matches;

export const useMediaQuery = (q) => {
  const [match, setMatch] = useState(() => query(q));
  useEffect(() => {
    const mq = window.matchMedia(q);
    const on = () => setMatch(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [q]);
  return match;
};

export const canUseWebGL = () => {
  try {
    const c = document.createElement("canvas");
    const gl = c.getContext("webgl2") || c.getContext("webgl");
    if (!gl) return false;
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return true;
  } catch {
    return false;
  }
};

// Feature flags for the homepage (site settings + device capabilities).
export const useHomeFlags = (site) => {
  const reduced = useMediaQuery("(prefers-reduced-motion: reduce)");
  const narrow = useMediaQuery("(max-width: 767px)");
  return {
    hero3d: site?.hero_3d_enabled !== false,
    anim: site?.home_animations_enabled !== false && !reduced && !narrow,
    reduced,
    narrow,
  };
};

export const formatTrNumber = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
